export enum COUNTRY_NAMES {
  AFGHANISTAN = 'AFGHANISTAN',
  ALAND_ISLANDS = 'ALAND ISLANDS',
  ALBANIA = 'ALBANIA',
  ALGERIA = 'ALGERIA',
  AMERICAN_SAMOA = 'AMERICAN SAMOA',
  ANDORRA = 'ANDORRA',
  ANGOLA = 'ANGOLA',
  ANGUILLA = 'ANGUILLA',
  ANTARCTICA = 'ANTARCTICA',
  ANTIGUA_AND_BARBUDA = 'ANTIGUA AND BARBUDA',
  ARGENTINA = 'ARGENTINA',
  ARMENIA = 'ARMENIA',
  ARUBA = 'ARUBA',
  AUSTRALIA = 'AUSTRALIA',
  AUSTRIA = 'AUSTRIA',
  AZERBAIJAN = 'AZERBAIJAN',
  BAHAMAS = 'BAHAMAS',
  BAHRAIN = 'BAHRAIN',
  BANGLADESH = 'BANGLADESH',
  BARBADOS = 'BARBADOS',
  BELARUS = 'BELARUS',
  BELGIUM = 'BELGIUM',
  BELIZE = 'BELIZE',
  BENIN = 'BENIN',
  BERMUDA = 'BERMUDA',
  BHUTAN = 'BHUTAN',
  BOLIVIA = 'BOLIVIA',
  BONAIRE_SAINT_EUSTATIUS_AND_SABA = 'BONAIRE, SAINT EUSTATIUS AND SABA',
  BOSNIA_AND_HERZEGOVINA = 'BOSNIA AND HERZEGOVINA',
  BOTSWANA = 'BOTSWANA',
  BOUVET_ISLAND = 'BOUVET ISLAND',
  BRAZIL = 'BRAZIL',
  BRITISH_INDIAN_OCEAN_TERRITORY = 'BRITISH INDIAN OCEAN TERRITORY',
  BRUNEI_DARUSSALAM = 'BRUNEI DARUSSALAM',
  BULGARIA = 'BULGARIA',
  BURKINA_FASO = 'BURKINA FASO',
  BURUNDI = 'BURUNDI',
  CAMBODIA = 'CAMBODIA',
  CAMEROON = 'CAMEROON',
  CANADA = 'CANADA',
  CANARY_ISLANDS = 'CANARY ISLANDS',
  CAPE_VERDE = 'CAPE VERDE',
  CAYMAN_ISLANDS = 'CAYMAN ISLANDS',
  CENTRAL_AFRICAN_REPUBLIC = 'CENTRAL AFRICAN REPUBLIC',
  CEUTA_AND_MELILLA = 'CEUTA AND MELILLA',
  CHAD = 'CHAD',
  CHILE = 'CHILE',
  CHINA = 'CHINA',
  CHRISTMAS_ISLAND = 'CHRISTMAS ISLAND',
  COCOS_ISLANDS = 'COCOS (KEELING) ISLANDS',
  COLOMBIA = 'COLOMBIA',
  COMOROS = 'COMOROS',
  DEMOCRATIC_REPUBLIC_OF_CONGO = 'CONGO, DEMOCRATIC REPUBLIC OF',
  REPUBLIC_OF_CONGO = 'CONGO, REPUBLIC OF',
  COOK_ISLANDS = 'COOK ISLANDS',
  COSTA_RICA = 'COSTA RICA',
  COTE_DIVOIRE = "COTE D'IVOIRE",
  CROATIA = 'CROATIA',
  CUBA = 'CUBA',
  CURAÇAO = 'CURAÇAO',
  CYPRUS = 'CYPRUS',
  CZECH_REPUBLIC = 'CZECH REPUBLIC',
  DENMARK = 'DENMARK',
  DJIBOUTI = 'DJIBOUTI',
  DOMINICA = 'DOMINICA',
  DOMINICAN_REPUBLIC = 'DOMINICAN REPUBLIC',
  EAST_TIMOR = 'EAST TIMOR',
  ECUADOR = 'ECUADOR',
  EGYPT = 'EGYPT',
  EL_SALVADOR = 'EL SALVADOR',
  EQUATORIAL_GUINEA = 'EQUATORIAL GUINEA',
  ERITREA = 'ERITREA',
  ESTONIA = 'ESTONIA',
  ETHIOPIA = 'ETHIOPIA',
  FALKLAND_ISLANDS = 'FALKLAND ISLANDS',
  FAROE_ISLANDS = 'FAROE ISLANDS',
  FIJI = 'FIJI',
  FINLAND = 'FINLAND',
  FRANCE = 'FRANCE',
  FRENCH_GUIANA = 'FRENCH GUIANA',
  FRENCH_POLYNESIA = 'FRENCH POLYNESIA',
  FRENCH_SOUTHERN_TERRITORIES = 'FRENCH SOUTHERN TERRITORIES',
  GABON = 'GABON',
  GAMBIA = 'GAMBIA',
  GEORGIA = 'GEORGIA',
  GERMANY = 'GERMANY',
  GHANA = 'GHANA',
  GIBRALTAR = 'GIBRALTAR',
  GREECE = 'GREECE',
  GREENLAND = 'GREENLAND',
  GRENADA = 'GRENADA',
  GUADELOUPE = 'GUADELOUPE',
  GUAM = 'GUAM',
  GUATEMALA = 'GUATEMALA',
  GUERNSEY = 'GUERNSEY',
  GUINEA = 'GUINEA',
  GUINEA_BISSAU = 'GUINEA-BISSAU',
  GUYANA = 'GUYANA',
  HAITI = 'HAITI',
  HEARD_AND_MCDONALD_ISLANDS = 'HEARD AND MCDONALD ISLANDS',
  VATICAN = 'HOLY SEE (CITY VATICAN STATE)',
  HONDURAS = 'HONDURAS',
  HONG_KONG = 'HONG KONG',
  HUNGARY = 'HUNGARY',
  ICELAND = 'ICELAND',
  INDIA = 'INDIA',
  INDONESIA = 'INDONESIA',
  IRAN = 'IRAN (ISLAMIC REPUBLIC OF)',
  IRAQ = 'IRAQ',
  IRELAND = 'IRELAND',
  ISLE_OF_MAN = 'ISLE OF MAN',
  ISRAEL = 'ISRAEL',
  ITALY = 'ITALY',
  JAMAICA = 'JAMAICA',
  JAPAN = 'JAPAN',
  JERSEY = 'JERSEY',
  JORDAN = 'JORDAN',
  KAZAKHSTAN = 'KAZAKHSTAN',
  KENYA = 'KENYA',
  KIRIBATI = 'KIRIBATI',
  DEMOCRATIC_REPUBLIC_KOREA = "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC",
  REPUBLIC_OF_KOREA = 'KOREA, REPUBLIC OF',
  KOSOVO = 'KOSOVO',
  KUWAIT = 'KUWAIT',
  KYRGYZSTAN = 'KYRGYZSTAN',
  LAO_PEOPLE_DEMOCRATIC_REPUBLIC = "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
  LATVIA = 'LATVIA',
  LEBANON = 'LEBANON',
  LESOTHO = 'LESOTHO',
  LIBERIA = 'LIBERIA',
  LIBYA = 'LIBYA',
  LIECHTENSTEIN = 'LIECHTENSTEIN',
  LITHUANIA = 'LITHUANIA',
  LUXEMBOURG = 'LUXEMBOURG',
  MACAU = 'MACAU',
  MACEDONIA = 'MACEDONIA',
  MADAGASCAR = 'MADAGASCAR',
  MALAWI = 'MALAWI',
  MALAYSIA = 'MALAYSIA',
  MALDIVES = 'MALDIVES',
  MALI = 'MALI',
  MALTA = 'MALTA',
  MARSHALL_ISLANDS = 'MARSHALL ISLANDS',
  MARTINIQUE = 'MARTINIQUE',
  MAURITANIA = 'MAURITANIA',
  MAURITIUS = 'MAURITIUS',
  MAYOTTE = 'MAYOTTE',
  MEXICO = 'MEXICO',
  FEDERAL_STATE_OF_MICRONESIA = 'MICRONESIA, FEDERAL STATE OF',
  REPUBLIC_OF_MOLDOVA = 'MOLDOVA, REPUBLIC OF',
  MONACO = 'MONACO',
  MONGOLIA = 'MONGOLIA',
  MONTENEGRO = 'MONTENEGRO',
  MONTSERRAT = 'MONTSERRAT',
  MOROCCO = 'MONTSERRAT',
  MOZAMBIQUE = 'MOZAMBIQUE',
  MYANMAR = 'MYANMAR (BURMA)',
  NAMIBIA = 'NAMIBIA',
  NAURU = 'NAURU',
  NEPAL = 'NEPAL',
  NETHERLANDS = 'NETHERLANDS',
  NETHERLANDS_ANTILLES = 'NETHERLANDS ANTILLES (DEPRECATED)',
  NEW_CALEDONIA = 'NEW CALEDONIA',
  NEW_ZEALAND = 'NEW ZEALAND',
  NICARAGUA = 'NICARAGUA',
  NIGER = 'NIGER',
  NIGERIA = 'NIGERIA',
  NIUE = 'NIUE',
  NORFOLK_ISLAND = 'NORFOLK ISLAND',
  NORTHERN_MARIANA_ISLANDS = 'NORTHERN MARIANA ISLANDS',
  NORWAY = 'NORWAY',
  OMAN = 'OMAN',
  PAKISTAN = 'PAKISTAN',
  PALAU = 'PALAU',
  PANAMA = 'PANAMA',
  PAPUA_NEW_GUINEA = 'PAPUA NEW GUINEA',
  PARAGUAY = 'PARAGUAY',
  PERU = 'PERU',
  PHILIPPINES = 'PHILIPPINES',
  PITCAIRN_ISLAND = 'PITCAIRN ISLAND',
  POLAND = 'POLAND',
  PORTUGAL = 'PORTUGAL',
  PUERTO_RICO = 'PUERTO RICO',
  QATAR = 'QATAR',
  REUNION_ISLAND = 'REUNION ISLAND',
  ROMANIA = 'ROMANIA',
  RUSSIAN_FEDERATION = 'RUSSIAN FEDERATION',
  RWANDA = 'RWANDA',
  SAINT_BARTHÉLEMY = 'SAINT BARTHÉLEMY',
  SAINT_HELENA = 'SAINT HELENA',
  SAINT_KITTS_AND_NEVIS = 'SAINT KITTS AND NEVIS',
  SAINT_LUCIA = 'SAINT LUCIA',
  SAINT_MARTIN = 'SAINT MARTIN',
  SAINT_VINCENT_AND_THE_GRENADINES = 'SAINT VINCENT AND THE GRENADINES',
  SAMOA = 'SAMOA',
  SAN_MARINO = 'SAN MARINO',
  SAO_TOME_AND_PRINCIPE = 'SAO TOME AND PRINCIPE',
  SAUDI_ARABIA = 'SAUDI ARABIA',
  SENEGAL = 'SENEGAL',
  SERBIA = 'SERBIA',
  SERBIA_AND_MONTENEGRO = 'SERBIA AND MONTENEGRO (DEPRECATED)',
  SEYCHELLES = 'SEYCHELLES',
  SIERRA_LEONE = 'SIERRA LEONE',
  SINGAPORE = 'SINGAPORE',
  SINT_MAARTEN = 'SINT MAARTEN',
  SLOVAK_REPUBLIC = 'SLOVAK REPUBLIC',
  SLOVENIA = 'SLOVENIA',
  SOLOMON_ISLANDS = 'SOLOMON ISLANDS',
  SOMALIA = 'SOMALIA',
  SOUTH_AFRICA = 'SOUTH AFRICA',
  SOUTH_GEORGIA = 'SOUTH GEORGIA',
  SOUTH_SUDAN = 'SOUTH SUDAN',
  SPAIN = 'SPAIN',
  SRI_LANKA = 'SRI LANKA',
  ST_PIERRE_AND_MIQUELON = 'ST. PIERRE AND MIQUELON',
  STATE_OF_PALESTINE = 'STATE OF PALESTINE',
  SUDAN = 'SUDAN',
  SURINAME = 'SURINAME',
  SVALBARD_AND_JAN_MAYEN_ISLANDS = 'SVALBARD AND JAN MAYEN ISLANDS',
  SWAZILAND = 'SWAZILAND',
  SWEDEN = 'SWEDEN',
  SWITZERLAND = 'SWITZERLAND',
  SYRIAN_ARAB_REPUBLIC = 'SYRIAN ARAB REPUBLIC',
  TAIWAN = 'TAIWAN',
  TAJIKISTAN = 'TAJIKISTAN',
  TANZANIA = 'TANZANIA',
  THAILAND = 'THAILAND',
  TOGO = 'TOGO',
  TOKELAU = 'TOKELAU',
  TONGA = 'TONGA',
  TRINIDAD_AND_TOBAGO = 'TRINIDAD AND TOBAGO',
  TUNISIA = 'TUNISIA',
  TURKEY = 'TURKEY',
  TURKMENISTAN = 'TURKMENISTAN',
  TURKS_AND_CAICOS_ISLANDS = 'TURKS AND CAICOS ISLANDS',
  TUVALU = 'TUVALU',
  UGANDA = 'UGANDA',
  UKRAINE = 'UKRAINE',
  UNITED_ARAB_EMIRATES = 'UNITED ARAB EMIRATES',
  UNITED_KINGDOM = 'UNITED KINGDOM',
  UNITED_STATES = 'UNITED STATES',
  URUGUAY = 'URUGUAY',
  US_MINOR_OUTLYING_ISLANDS = 'US MINOR OUTLYING ISLANDS',
  UZBEKISTAN = 'UZBEKISTAN',
  VANUATU = 'VANUATU',
  VENEZUELA = 'VENEZUELA',
  VIETNAM = 'VIETNAM',
  VIRGIN_ISLANDS_BRITISH = 'VIRGIN ISLANDS (BRITISH)',
  VIRGIN_ISLANDS_USA = 'VIRGIN ISLANDS (USA)',
  WALLIS_AND_FUTUNA = 'WALLIS AND FUTUNA',
  WESTERN_SAHARA = 'WESTERN SAHARA',
  YEMEN = 'YEMEN',
  ZAMBIA = 'ZAMBIA',
  ZIMBABWE = 'ZIMBABWE',
}
